import { shopifyListingIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const clearListingImages = {
  name: "clearListingImages" as const,
  input: z.object({ shopifyListingId: shopifyListingIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
